// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2OOFW","list":"styles_list__2XEwJ"};